export const themes = {
  default: {
    thRoot: 'flex flex-col sm:flex-row gap-20 sm:items-center',
    thLabel: 'flex flex-col sm:flex-row sm:flex-1 gap-5 sm:gap-10 items-center text-center',
    thLabelIconSize: '1.25rem',
    thText: 'font-bold',
    thList: 'flex flex-col sm:flex-row gap-10 shrink-0 flex-start',
    thListItem: 'flex gap-5 justify-center',
    thListItemIcon: 'shrink-0',
    thLink:
      ' inline-flex flex-row-reverse font-bold items-center text-black hocus:text-black-active text-12 transition-color duration-250 ease-in underline',
  },
  lite: {
    thRoot: 'flex flex-col sm:flex-row gap-10 sm:gap-20 sm:items-center',
    thLabel: 'flex flex-row items-center gap-5',
    thLabelIconSize: '1rem',
    thText: 'font-bold',
    thList: 'flex flex-col sm:flex-row gap-10 shrink-0',
    thListItem: 'flex items-center gap-5 text-sienna w-full sm:w-auto',
    thListItemIcon: 'shrink-0',
    thListItemIconSize: '1.3rem',
    thLink:
      ' inline-block font-bold items-center text-black hocus:text-black-active text-14 transition-color duration-250 ease-in underline w-full',
  },
};
